export function route(path: any, params = {}) {
  return Object.keys(params)
    .reduce((acc, token) => acc.replace(token.replace(/^:?/, ':'), params[token]), path)
    .replace(/\/+/g, '/')
}
